import SectionHeading from './SectionHeading';

const stats = [
  { value: '6 类', label: '常见入口形式' },
  { value: '3 步', label: '找回最新地址' },
  { value: '多端', label: '收藏与防走失' },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <SectionHeading
              eyebrow="平台简介"
              title="茶杯狐影视是一个围绕影视内容浏览的入口平台"
              desc="对大多数用户来说，真正需要记住的不是某一条随时可能变化的链接，而是一套「入口 + 发布页 + 防走失」的组合方法。"
            />
            <div className="space-y-5 text-sm md:text-base leading-relaxed text-foreground-700">
              <p>
                茶杯狐影视以影视资源聚合为主要方向，提供影片与剧集的浏览入口。用户通常通过官网入口进入平台，
                再按分类、频道或搜索的方式找到想看的内容，而不是依赖某一个固定的页面地址。
              </p>
              <p>
                由于入口地址有时会随网络环境变化而调整，围绕「最新地址、官方网址、发布页与永久入口」的信息说明就显得格外重要。
                本页把这几类信息集中梳理，帮助你在入口发生变动时依然能够顺着线索找回官方去向。
              </p>
              <p>
                需要说明的是，本页为入口信息的一般性整理与说明，具体可用地址以平台官方最新公布的内容为准。
                我们更希望帮你建立「知道该去哪里找」的习惯，而不只是提供一个随时可能失效的链接。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-3 md:gap-5">
              {stats.map((s) => (
                <div key={s.label} className="rounded-lg border border-background-200 bg-background-100 p-4">
                  <div className="font-heading text-xl md:text-2xl font-bold text-primary-700">{s.value}</div>
                  <div className="mt-1 text-xs md:text-sm text-foreground-600">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[320px] md:h-[460px] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20warm%20editorial%20illustration%20of%20a%20cozy%20ceramic%20tea%20cup%20beside%20a%20minimalist%20film%20reel%20and%20soft%20geometric%20shapes%2C%20cream%20and%20ochre%20palette%20with%20terracotta%20accents%2C%20flat%20vector%20aesthetic%2C%20clean%20simple%20background%2C%20generous%20negative%20space%2C%20no%20text&width=900&height=1100&seq=cupfox-about-01&orientation=portrait"
                alt="茶杯与胶片元素构成的插画，象征茶杯狐影视的影视浏览入口定位"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-4 md:left-8 right-4 md:right-auto md:w-72 rounded-lg bg-accent-500 p-4 md:p-5">
              <div className="flex items-center gap-2 text-background-50">
                <i className="ri-megaphone-line text-lg"></i>
                <span className="font-heading text-sm font-semibold">记住发布页</span>
              </div>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-background-50/90">
                发布页是入口的入口，地址变化时优先回访它。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}